module.exports = __webpack_public_path__ + "static/media/product_view_seller.be76ee0a.png";